import { t } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { Badge } from 'designSystem/components/Badge'
import { Box } from 'designSystem/components/Box'
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from 'designSystem/components/DropdownMenu'
import { Text } from 'designSystem/components/Text'
import {
  formatRevisionLabel,
  type RevisionMenuItemView,
} from 'features/knowledgeDocumentViewer/utils/revisionHelpers'
import React, { useCallback } from 'react'

export type RevisionFamilyDropdownItemProps = {
  item: RevisionMenuItemView
  isLoading: boolean
  onSelect: () => void
}

function itemStatusLabel(
  item: RevisionMenuItemView,
  isLoading: boolean
): string {
  if (item.isCurrent) return t`Current`
  if (item.isSelectable) return t`Select`
  return isLoading ? t`Loading…` : t`Unavailable`
}

export function RevisionFamilyDropdownItem({
  item,
  isLoading,
  onSelect,
}: RevisionFamilyDropdownItemProps): React.ReactElement {
  useLingui()

  const handleSelect = useCallback(() => {
    if (item.isCurrent) return
    onSelect()
  }, [item.isCurrent, onSelect])

  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuItem
        variant='comfortable'
        disabled={!item.isCurrent && !item.isSelectable}
        onSelect={handleSelect}>
        <Box display='flex' direction='column' flex='one' minWidth='none'>
          <Text truncate>{formatRevisionLabel(item.code)}</Text>
          <Text color='muted' truncate>
            {item.date?.trim() ?? ''}
          </Text>
        </Box>
        <Badge variant={item.isCurrent ? 'outlineMuted' : 'outline'}>
          {itemStatusLabel(item, isLoading)}
        </Badge>
      </DropdownMenuItem>
    </>
  )
}
